<template>

	<transition
		name="dialog-fade"
		@after-enter="afterEnter"
		@after-leave="afterLeave">
		<div class="vue-dialog-wrapper" v-show="visible">
			<div class="vue-dialog" ref="dc" :style="style">
				<div class="vue-dialog-close" @click="handleClose">
					<i class="close-icon"/>
				</div>
				<div class="vue-dialog-header" v-if="$slots.header || title">
					<slot name="header">
						<span class="vue-dialog-title">{{ title }}</span>
					</slot>
				</div>
				<div class="vue-dialog-body">
					<slot></slot>
				</div>
				<div class="vue-dialog-footer" v-if="$slots.footer">
					<slot name="footer"></slot>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
    export default {
        name: "Dialog",
        props: {
            title: {
                type: String,
                default: ''
            },
            visible: {
                type: Boolean,
                default: false
            },
            width: String,
        },
        data() {
            return {
                closed: false,
            };
        },
        computed: {
            style() {
                let style = {};
                if (this.width) {
                    style.width = this.width;
                }
                return style;
            }
        },
        watch: {
            visible(val) {
                if (val) {
                    this.closed = false;
                    this.$emit('open');
                } else {
                    if (!this.closed) this.$emit('close');
                }
            }
        },
        methods: {
            handleClose() {
                this.hide();
            },
            hide(cancel) {
                if (cancel !== false) {
                    this.$emit('update:visible', false);
                    this.$emit('close');
                    this.closed = true;
                }
            },
            afterEnter() {
                this.$emit('opened');
            },
            afterLeave() {
                this.$emit('closed');
            }
        },
    }
</script>

<style lang="scss" scoped>

	@-webkit-keyframes vicp {
		0% {
			opacity: 0;
			-webkit-transform: scale(0) translatey(-60px);
			transform: scale(0) translatey(-60px);
		}
		100% {
			opacity: 1;
			-webkit-transform: scale(1) translatey(0);
			transform: scale(1) translatey(0);
		}
	}

	@keyframes vicp {
		0% {
			opacity: 0;
			-webkit-transform: scale(0) translatey(-60px);
			transform: scale(0) translatey(-60px);
		}
		100% {
			opacity: 1;
			-webkit-transform: scale(1) translatey(0);
			transform: scale(1) translatey(0);
		}
	}

	.vue-dialog-wrapper {
		position: fixed;
		display: block;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		z-index: 10000;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		padding-top: 50vh;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.65);
		-webkit-tap-highlight-color: transparent;
		-moz-tap-highlight-color: transparent;
	}


	.vue-dialog-wrapper .vue-dialog {
		-webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);
		box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);
		position: relative;
		display: block;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		/*z-index: 10000;*/
		/*top: 0;*/
		/*bottom: 0;*/
		/*left: 0;*/
		/*right: 0;*/
		margin: 0 auto;
		transform:translate(0,-50%);
		width: 50%;
		/*padding: 25px;*/
		background-color: #fff;
		border-radius: 2px;
		-webkit-animation: vicp 0.12s ease-in;
		animation: vicp 0.12s ease-in;
	}


	.vue-dialog-wrapper .vue-dialog .vue-dialog-close {
		position: absolute;
		right: -30px;
		top: -30px;
	}

	.vue-dialog-wrapper .vue-dialog .vue-dialog-close .close-icon {
		position: relative;
		display: block;
		width: 30px;
		height: 30px;
		cursor: pointer;
		-webkit-transition: -webkit-transform 0.18s;
		transition: -webkit-transform 0.18s;
		transition: transform 0.18s;
		transition: transform 0.18s, -webkit-transform 0.18s;
		-webkit-transform: rotate(0);
		-ms-transform: rotate(0);
		transform: rotate(0);
	}

	.vue-dialog-wrapper .vue-dialog .vue-dialog-close .close-icon::after,
	.vue-dialog-wrapper .vue-dialog .vue-dialog-close .close-icon::before {
		-webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);
		box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);
		content: "";
		position: absolute;
		top: 12px;
		left: 4px;
		width: 20px;
		height: 3px;
		-webkit-transform: rotate(45deg);
		-ms-transform: rotate(45deg);
		transform: rotate(45deg);
		background-color: #fff;
	}

	.vue-dialog-wrapper .vue-dialog .vue-dialog-close .close-icon::after {
		-webkit-transform: rotate(-45deg);
		-ms-transform: rotate(-45deg);
		transform: rotate(-45deg);
	}

	.vue-dialog-wrapper .vue-dialog .vue-dialog-close .close-icon:hover {
		-webkit-transform: rotate(90deg);
		-ms-transform: rotate(90deg);
		transform: rotate(90deg);
	}
	.vue-dialog-header, .vue-dialog-footer{
		padding: 25px;
	}
	.vue-dialog-title{
		line-height: 24px;
		font-size: 18px;
		color: #303133;
	}
	.vue-dialog-footer{
		text-align: right;
	}
	.vue-dialog-footer .btn{
		margin-left: 10px;
	}

</style>